// Axios setup
import VueAxios from "vue-axios";
import authHeader from "@/modules/auth/services/auth-header";
import Vue from "vue";
import store from "@/store";
import router from "@/router";
import { saveRedirectionIntoStorage } from "@/util/helpers/LoginRedirectionHelpers/LoginRedirectionHelpers";
import {
  CURRENT_ARAFAT_URL_BACK,
  CURRENT_ARAFAT_URL_FRONT,
  CURRENT_MOZDALIFA_URL_BACK,
  CURRENT_MOZDALIFA_URL_FRONT,
  CURRENT_MENA_URL_BACK,
  CURRENT_MENA_URL_FRONT
} from "./url"
const axios = require("axios");
Vue.use(VueAxios, axios);


Vue.prototype.$baseArafatURL = CURRENT_ARAFAT_URL_BACK;
Vue.prototype.$frontArafatURL = CURRENT_ARAFAT_URL_FRONT;

Vue.prototype.$baseMozdalifaURL = CURRENT_MOZDALIFA_URL_BACK;
Vue.prototype.$frontMozdalifaURL = CURRENT_MOZDALIFA_URL_FRONT;

Vue.prototype.$baseMenaURL = CURRENT_MENA_URL_BACK;
Vue.prototype.$frontMenaURL = CURRENT_MENA_URL_FRONT;

Vue.prototype.$frontURL = "https://tsleem.com.sa/";

const baseUrl = localStorage.getItem("baseUrl") || CURRENT_MENA_URL_BACK + "api";
// if (!localStorage.hasOwnProperty("baseUrl")) {
//   localStorage.setItem("baseUrl", CURRENT_MENA_URL_BACK + "api");
//   localStorage.setItem("name_systemt", 'مشعر منى');
//   localStorage.setItem("type_system", 'mina');

// }
const ENDPOINT_BASE_API = baseUrl;

window.axios = require("axios");
axios.defaults.baseURL = ENDPOINT_BASE_API;
axios.interceptors.request.use(function (config) {
  config.headers = authHeader();
  return config;
});
axios.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    console.log(error)

    if (error.response && error.response.status == 401) {
      console.log(router)
        ; store
          .dispatch("auth/logout")
          .then(() => {
            const prevPath = router.history._startLocation ?? undefined;
            saveRedirectionIntoStorage(prevPath);
            router.push({ path: `/login` });
          })
          .catch((err) => console.log(err));
    }
    return Promise.reject(error);
  }
);
